// Noble Accounting Services — Monogram Logo (SVG)
// Classical crested mark: double border, serif "N", MMX (2010) roman numeral.
// Accepts size (px) and className to inherit currentColor.

export default function Logo({ size = 40, className = "", withFrame = true, letter = "N" }) {
    return (
        <svg
            viewBox="0 0 64 64"
            width={size}
            height={size}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Noble Accounting Services"
            data-testid="brand-logo"
        >
            {withFrame && (
                <>
                    <rect x="1.5" y="1.5" width="61" height="61" fill="none" stroke="currentColor" strokeWidth="1" />
                    <rect x="5" y="5" width="54" height="54" fill="none" stroke="currentColor" strokeWidth="0.5" />
                    {/* top & bottom hairlines flanking the monogram */}
                    <line x1="16" y1="10.5" x2="26" y2="10.5" stroke="currentColor" strokeWidth="0.6" />
                    <line x1="38" y1="10.5" x2="48" y2="10.5" stroke="currentColor" strokeWidth="0.6" />
                    <circle cx="32" cy="10.5" r="1" fill="currentColor" />
                    <line x1="16" y1="53.5" x2="26" y2="53.5" stroke="currentColor" strokeWidth="0.6" />
                    <line x1="38" y1="53.5" x2="48" y2="53.5" stroke="currentColor" strokeWidth="0.6" />
                </>
            )}
            {/* Serifed monogram letter */}
            <text
                x="32"
                y="42"
                textAnchor="middle"
                fontFamily="'Cormorant Garamond', Georgia, serif"
                fontSize="34"
                fontWeight="500"
                fill="currentColor"
            >
                {letter}
            </text>
            {/* Tiny Roman-numeral year for grandeur */}
            <text
                x="32"
                y="51"
                textAnchor="middle"
                fontFamily="'IBM Plex Mono', monospace"
                fontSize="3.4"
                letterSpacing="1.4"
                fill="currentColor"
                opacity="0.9"
            >
                MMX
            </text>
        </svg>
    );
}
